import { useNavigate, useParams } from "react-router-dom";
import MapWidget from "../../../widgets/map/mapWidget/MapWidget";
import { useEffect, useState } from "react";
import { getBasicObjectTypeLayer } from "../../../widgets/map/mapFeatures/layers";
import { getItemWebStorage } from "../../../features/webStorageSaver";
import { getObjectsOnCustomMapPoint } from "../../../widgets/map/mapFeatures/mapFunctions/getObjectsOnMapPoint/getObjectsOnMapPoint";
import { MapOverlayWidget } from "../../../widgets/map/mapAddons/mapOverlayWidget";
import { useAppSelector } from "../../../stateManagement/hooks/redux";
import ContentHeader from "../../../widgets/contentHeader/ContentHeader";

// Компонент для отображения карты объектов определенного типа без дополнительной логики, а также для отображения дополнительных разделов карты из конфигурации
export function CustomMapObjectType() {
    const { id, objectType: urlObjectTypeName }: any = useParams()
    const navigate = useNavigate();
    const [mapTitle, setMapTitle] = useState<string>('');
    const [additionalLayers, setAdditionalLayers] = useState<any>([]);
    const [permanentLayers, setPermanentLayers] = useState<any>([])
    const [focusedLayer, setFocusedLayer] = useState<any>([])
    const customMapFilterString = useAppSelector(state => state.customMap.customMapFilterString)
    const currentConfig = getItemWebStorage('currentConfig')
    const { mapAdditionalItems } = currentConfig ?? {}
    const mapAdditionalItem = mapAdditionalItems.find((item: any) => item?.id === id)
    const { additionalLayers: configAdditionalLayers, permanentLayers: configPermanentLayers, wmsServer, wmsVersion, workspace, title, mapFilterOptions } = mapAdditionalItem ?? {}

    useEffect(() => {
        const mapTitle = `Карта «${title}»`
        mapTitle && setMapTitle(mapTitle)
        if (!configAdditionalLayers) {
            navigate('/app/error')
        }
        let layerFilter = null
        if (configAdditionalLayers && customMapFilterString) {
            layerFilter = customMapFilterString
        }
        const customObjectTypeLayer = getBasicObjectTypeLayer(configAdditionalLayers, wmsServer, wmsVersion, workspace, layerFilter)
        const additionalLayers = [customObjectTypeLayer]
        setFocusedLayer(customObjectTypeLayer)
        setAdditionalLayers(additionalLayers)
    }, [urlObjectTypeName, customMapFilterString]);

    useEffect(() => {
        if (configPermanentLayers) {
            const permanentLayer = getBasicObjectTypeLayer(configPermanentLayers, wmsServer, wmsVersion, workspace)
            setPermanentLayers([permanentLayer])
        } else {
            setPermanentLayers([])
        }
    }, [configPermanentLayers])

    function applyMapObjectsFind(map: any) {
        let clickFunc = (event: any) => getObjectsOnCustomMapPoint(event, id, urlObjectTypeName, focusedLayer, navigate, map)
        map?.on("singleclick", clickFunc)
        return {
            off: () => {
                map?.un("singleclick", clickFunc)
            }
        }
    }

    const mapEventHandlers = [
        {
            name: "objectsFind",
            func: applyMapObjectsFind
        }
    ]

    return (
        <>
            <ContentHeader title={mapTitle} objectTypeName={urlObjectTypeName} type="map" />
            <div className="map-widget-with-toast">
                <MapWidget additionalLayers={additionalLayers} permanentLayers={permanentLayers} mapEventHandlers={mapEventHandlers} />
                <MapOverlayWidget type={urlObjectTypeName} mapFilterOptions={mapFilterOptions} />
            </div>
        </>
    )
}
